import DountChart from '@/components/charts/dount-chart/dount-chart';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { StruggleCompetency, StruggleData } from '@/models/groups/report';
import { generateColor } from '@/utils/utils';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as d3 from 'd3';
import StrugglingPanelCard from '@/components/cards/struggling-cards/struggling-panel-card/struggling-panel-card';

@Component({
    name: 'drilldown-struggle-pullup',
    components: {
        'material-icon': GoogleMaterialIcon,
        'dount-chart': DountChart,
        'struggle-panel': StrugglingPanelCard,
    },
})

export default class DrilldownStrugglePullup extends Vue {

    // ----------------------------------------------------------------------
    // Properties

    @Prop()
    private strugglingCompetencies!: StruggleData[];

    @Prop()
    private subjectList: any;

    @Prop()
    private selectedSubject: any;
    @Prop()
    private isLoading!: boolean;

    private activeSubject: any = null;

    private get chartData() {
        return this.getChartData();
    }

    private showMore: boolean = false;

    @Prop()
    private groupType!: string;

    @Prop()
    private parentGroupName!: any;

    @Prop()
    private groupLabel!: any;


    private enableRightScroll: boolean = false;

    private enableLeftScroll: boolean = false;

    // @Prop()
    // private isLearningChallenge!: boolean;
    private isLearningChallenge: boolean = false;

    @Prop()
    private learningReportData: any;

    @Prop()
    private groupName: any;

    // ----------------------------------------------------------------------
    // Hooks

    private created() {
        this.activeSubject = this.selectedSubject ? this.selectedSubject : null;
    }

    private mounted() {
        this.onScrollActions();
    }

    // -----------------------------------------------------------------------------
    // Actions

    private onSelectStrunggleSubject(subject: any = null) {
        this.activeSubject = subject;
        this.$emit('onSelectStrunggleSubject', subject);
    }

    private onSelectLevel(level: any, cardName: string) {
        this.$emit('onSelectLevel', level, this.activeSubject, cardName);
    }



    // ----------------------------------------------------------------------------
    // Methods

    private getChartData() {
        const learningReportData = this.learningReportData;
        const chartData: any = [];
        const sequenceColor: any = d3.scaleLinear().domain([1, learningReportData.length])
            .range(['#00ace9' as any, '#c1dbee' as any]);
        learningReportData.forEach((grade: any, index: number) => {
            chartData.push({
                name: grade.grade,
                value: grade.competencyCount,
                color: sequenceColor(index),
            });
        });
        return chartData;
    }

    private iconLoader(competencies: StruggleCompetency[], count: any) {
        const userCount = count <= 7 ? count : 7;
        return userCount ? new Array(userCount).fill({}) : [];
    }

    private onScrollActions() {
        const bodyContainer: null | any = this.$el.querySelector('.struggle-nav-tab-panel');
        if (bodyContainer.scrollWidth > bodyContainer.clientWidth) {
            this.enableRightScroll = true;
        }
        let startPosition = bodyContainer.scrollLeft;
        bodyContainer.onscroll = () => {
            if (bodyContainer.scrollLeft > startPosition) {
                this.enableLeftScroll = true;
                const clientWidth = bodyContainer.scrollWidth - bodyContainer.scrollLeft;
                if (clientWidth === bodyContainer.clientWidth) { this.enableRightScroll = false; }
            }
            if (bodyContainer.scrollLeft < startPosition) {
                this.enableRightScroll = true;
                if (bodyContainer.scrollLeft === 0) { this.enableLeftScroll = false; }
            }
            startPosition = bodyContainer.scrollLeft;
        };
    }

    private scollWithButtons(action: any) {
        const bodyContainer: null | any = this.$el.querySelector('.struggle-nav-tab-panel');
        if (action === 'Right') {
            bodyContainer.scrollLeft += 150;
            this.enableLeftScroll = true;
            const clientWidth = bodyContainer.scrollWidth - bodyContainer.scrollLeft;
            if (clientWidth === bodyContainer.clientWidth) { this.enableRightScroll = false; }
        }
        if (action === 'Left') {
            bodyContainer.scrollLeft -= 150;
            this.enableRightScroll = true;
            if (bodyContainer.scrollLeft === 0) { this.enableLeftScroll = false; }
        }
    }
}
